import {
  Checkbox,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Stack,
  Typography,
} from "@mui/material";
import {
  GROUP_VOLUNTEER_REGION_LABELS,
  GROUP_VOLUNTEER_REGIONS,
  type GroupVolunteerRegion,
  toggleGroupVolunteerRegion,
} from "@shared/helpers/group-volunteer-regions";
import React, { type FC } from "react";

interface GroupVolunteerRegionsFieldProps {
  value: GroupVolunteerRegion[];
  onChange: (regions: GroupVolunteerRegion[]) => void;
  error?: string;
}

export const GroupVolunteerRegionsField: FC<GroupVolunteerRegionsFieldProps> = ({
  value,
  onChange,
  error,
}) => {
  return (
    <Stack
      className="field-container"
      spacing={0.5}
      data-field="preferredVolunteerRegions"
      data-form-error={error ? "" : undefined}
    >
      <FormLabel className="field-label">
        באילו אזורים הקבוצה מעוניינת להתנדב?
      </FormLabel>
      <Typography variant="body2" color="text.secondary">
        ניתן לבחור יותר מאפשרות אחת
      </Typography>
      <Stack spacing={0.25}>
        {GROUP_VOLUNTEER_REGIONS.map((region: GroupVolunteerRegion) => (
          <FormControlLabel
            key={region}
            control={
              <Checkbox
                checked={value.includes(region)}
                onChange={() =>
                  onChange(toggleGroupVolunteerRegion(value, region))
                }
              />
            }
            label={GROUP_VOLUNTEER_REGION_LABELS[region]}
          />
        ))}
      </Stack>
      {error ? (
        <FormHelperText error sx={{ mx: 0 }}>
          {error}
        </FormHelperText>
      ) : null}
    </Stack>
  );
};
